import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d1f7357"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1f7357')) {
      api.createRecord('1d1f7357', component.options)
    } else {
      api.reload('1d1f7357', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1d1f7357", function () {
      api.rerender('1d1f7357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabInputNumber/index.vue"
export default component.exports